import {Component} from "@angular/core";
import {AuthorizationService} from "../Authorization/AuthorizationService";

@Component({
    providers: [AuthorizationService],
    template: ""
})

export class UnauthorizedAccessComponent {
    constructor(private authorizationService: AuthorizationService) {
        authorizationService.handleUnauthorized();
    }
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Authorization/UnauthorizedAccessComponent.ts